import { gql, TypedDocumentNode } from '@apollo/client'

export type TeamUpdateInput = {
  teamId: string
  teamType: string
  teamName?: string
  statusCode?: number
  members?: Array<{
    userProfileId: string
    roles: Array<number>
  }>
}

export const UPDATE_TEAM_MUTATION: TypedDocumentNode<
  { updateTeam: { id: string } },
  { teamUpdateInput: TeamUpdateInput }
> = gql`
  mutation updateTeam($teamUpdateInput: TeamUpdateInput!) {
    updateTeam(teamUpdateInput: $teamUpdateInput) {
      id
    }
  }
`

type createTeamResponse = {
  createTeam: {
    id: string
  }
}

type createTeamVariables = {
  teamInput: {
    teamName: string
    teamType: string
    resourceType?: string
    purpose?: string
    partnerId?: string
    partnerType?: number | null
    members?: Array<{
      roles: Array<any>
      userProfileId: string
    }>
  }
}

export const CREATE_TEAM_MUTATION: TypedDocumentNode<
  createTeamResponse,
  createTeamVariables
> = gql`
  mutation createTeam($teamInput: TeamInput!) {
    createTeam(teamInput: $teamInput) {
      id
    }
  }
`
